import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getHousing, createHousing, updateHousing } from '../api/employeesHousing.api';
import { IHousing, IGetHousing } from '../models/employeesHousing.model';

interface IHousingState {
  housing: IHousing|null;
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IHousingState = {
  housing: null,
  isLoading: false
};

const housingSlicer = createSlice({
  name: 'housing',
  initialState,
  reducers: {
    getHousingStart: (state: IHousingState) => {
      state.housing = null;
      state.isLoading = true;
      state.error = undefined;
    },
    getHousingSuccess: (state: IHousingState, action: PayloadAction<IGetHousing>) => {
      state.housing = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getHousingFailure: (state: IHousingState, action: PayloadAction<AxiosError|string>) => {
      state.housing = null;
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IHousingState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IHousingState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IHousingState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    updateSuccess: (state: IHousingState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  }
});

export const {
  getHousingStart,
  getHousingSuccess,
  getHousingFailure,
  requestStart,
  requestFailure,
  createSuccess,
  updateSuccess
} = housingSlicer.actions;

export default housingSlicer.reducer;

export const doGetHousing = (memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getHousingStart());
    const response = await getHousing(memberCode);
    dispatch(getHousingSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getHousingFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateHousing = (memberCode: string, data: any): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createHousing(memberCode, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doUpdateHousing = (memberCode: string, data: any): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await updateHousing(memberCode, data);
    dispatch(updateSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
